import React, { forwardRef, useState } from "react";

import {
  IconButton,
  InputAdornment,
  TextFieldProps,
  TextField,
  Skeleton,
  useTheme,
} from "@mui/material";

import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";

type Props = {
  suffix?: JSX.Element | string;
  fullWidth?: boolean;
  password?: boolean;
  loading?: boolean;
} & TextFieldProps;

const Input = forwardRef<HTMLInputElement, Props>(
  ({ suffix, fullWidth, loading, password, ...rest }, ref) => {
    const [showPass, setShowPass] = useState(false);
    const Wrapper = loading ? Skeleton : React.Fragment;
    const theme = useTheme();

    return (
      <Wrapper
        {...(loading
          ? {
              variant: "rounded",
              width: "100%",
              height: theme.mixins.toolbar.height,
            }
          : {})}
      >
        <TextField
          type={password ? (showPass ? "text" : "password") : "text"}
          ref={ref}
          InputProps={{
            startAdornment: suffix && (
              <InputAdornment position="start">{suffix}</InputAdornment>
            ),
            endAdornment: password && (
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={() => setShowPass(!showPass)}
                  edge="end"
                >
                  {showPass ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            ),
          }}
          fullWidth={fullWidth}
          {...rest}
        />
      </Wrapper>
    );
  }
);

export default Input;
